export const TRANSLATIONS_BN = {
  login: {
    welcome: "স্বাগত",
    username: "ব্যবহারকারীর নাম",
    password: "পাসওয়ার্ড",
    usernamePlaceholder: "নিবন্ধিত ইমেল / ব্যবহারকারীর নাম",
    signIn: "সাইন ইন করুন",
    forgotPassword: "পাসওয়ার্ড ভুলে গেছেন",
    noAccount: "একটি অ্যাকাউন্ট নেই?",
    registerNow: "এখন নিবন্ধন করুন",
    noUsername: "আপনার ব্যবহারকারীর নাম ইনপুট করুন!",
    noPassword: "আপনার পাসওয়ার্ড ইনপুট করুন!",
  },
  register: {
    newUser: "নতুন ব্যবহারকারী",
    registerHere: "এখানে নিবন্ধন করুন",
    email: "ইমেইল",
    emailPlaceholder: "আপনার নিবন্ধিত ইমেইল লিখুন",
    mobileNo: "মোবাইল নাম্বার",
    createPassword: "গুপ্ত সংকেত সৃষ্টি করুন",
    confirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
    passwordAgain: "আবার পাসওয়ার্ড টাইপ করুন",
    mobilePlease: "মোবাইল নম্বর দয়া করে",
    signUp: "নিবন্ধন করুন",
    alreadyHaveAccount: "ইতিমধ্যে একটি সদস্যপদ আছে!",
    signIn: "সাইন ইন করুন",
    noMobileNo: "আপনার মোবাইল নম্বর ইনপুট করুন!",
    noEmail: "আপনার ইমেল ইনপুট দয়া করে!",
    noPassword: "আপনার পাসওয়ার্ড ইনপুট করুন!",
    noConfirmPassword: "আপনার নিশ্চিত পাসওয়ার্ড ইনপুট করুন!",
  },
  verify: {
    title: "OTP দিয়ে যাচাই করুন",
    otpOn: "আমরা একটি ওটিপি পাঠিয়েছি",
    registeredEmail: "এবং আপনার নিবন্ধিত ইমেল ঠিকানা",
    codeNotReceived: "আমি একটি কোড গ্রহণ করিনি.",
    resend: "আবার পাঠান",
    itOr: "এটা বা",
    details: "বিস্তারিত",
    changeRegistrationDetails: "রেজিস্ট্রেশনের বিবরণ পরিবর্তন করুন",
    verify: "যাচাই করুন",
  },
};
